import React, { useState } from "react";
import Container from "../../Atoms/Container/Container";
import "./LandingPage.scss";
import { ROUTES, STYLES } from "../../../Helpers/Constants";
import Header from "../../Molecules/Header/Header";
import Monogram from "../../Atoms/Monogram/Monogram";
import mono from "../../../Assets/LandingPageAssets/badge.svg";
import HeaderStyledText from "../../Molecules/HeaderStyledText/HeaderStyledText";
import BriefIntro from "../../Molecules/BriefIntro/BriefIntro";
import ContentSample from "../../Molecules/ContentSample/ContentSample";
import LandingPageFooter from "../../Molecules/LandingPageFooter/LandingPageFooter";
import LandingPageBottom from "../../Molecules/LandingPageBottom/LandingPageBottom";
import HeroBanner from "../../Molecules/HeroBanner/HeroBanner";
import MainMenuBar from "../../Molecules/MainMenuBar/MainMenuBar";
import { useNavigate } from "react-router-dom";
const LandingPage = () => {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const handleSignUpClick = () => {
    navigate(ROUTES?.USER_SIGN_UP);
  };
  return (
    <Container className={STYLES?.LANDING_PAGE_MAIN_CONTAINER}>
      <HeroBanner isOpen={isOpen} setOpen={setOpen} />

      {isOpen && <MainMenuBar handleSignUpClick={handleSignUpClick} />}
      <Container className={STYLES?.HEADER_BG_CONTAINER}>
        <Container className={STYLES?.LANDING_PAGE_HEADER_BG}>
          <Header />
        </Container>
        {/* <LogoBar className={STYLES?.LOGO_BAR_CONTAINER} /> */}
      </Container>
      <Container className={STYLES?.HEADER_TEXT_CONTAINER}>
        <HeaderStyledText />
        <Monogram imageSrc={mono} />
      </Container>
      {/* <LogoBar className={STYLES?.LOGO_BAR_SM_CONTAINER} /> */}
      <BriefIntro />
      <ContentSample />
      <LandingPageBottom />
      <LandingPageFooter />
    </Container>
  );
};

export default LandingPage;
